module.exports = __webpack_public_path__ + "static/img/Q.90a4ec9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/simba/Q.png
// module id = nq9/
// module chunks = 0